<template>
  <div>
    <div v-if="menuOpen" class="overlay" @click="closeMenu"></div>

    <aside class="sidebar" :class="{ 'is-open': menuOpen }" @click.stop>
      <div class="side-head">
        <img src="/assets/afrogato/logo-afrogato.png" alt="Afrogato" />
        <button class="icon-btn" type="button" @click="closeMenu" aria-label="Cerrar">×</button>
      </div>

      <nav class="menu-links">
        <router-link to="/dashboard" class="nav-link" @click="closeMenu">Inicio</router-link>
        <router-link to="/wallet" class="nav-link" @click="closeMenu">Mi wallet</router-link>
        <router-link to="/menu" class="nav-link" @click="closeMenu">Menu digital</router-link>
        <router-link v-if="isAdmin" to="/recetas" class="nav-link" @click="closeMenu">Recetario</router-link>
        <router-link v-if="isAdmin" to="/catalogo" class="nav-link" @click="closeMenu">Catalogo</router-link>
        <router-link v-if="isAdmin" to="/catalogo/promociones" class="nav-link" @click="closeMenu">Promociones animadas</router-link><router-link v-if="isAdmin" to="/catalogo/promocafe" class="nav-link" @click="closeMenu">PromoCafé horizontal</router-link>
        <router-link v-if="isAdmin" to="/configuracion/lealtad" class="nav-link" @click="closeMenu">Lealtad GT</router-link>
        <router-link v-if="isAdmin" to="/usuarios" class="nav-link" @click="closeMenu">Usuarios</router-link>
        <router-link :to="'/dashboard/user/edit/' + $store.state.user.token" class="nav-link" @click="closeMenu">Mi perfil</router-link>
        <button class="nav-link danger" type="button" @click="logoutAndClose">Cerrar sesion</button>
      </nav>
    </aside>

    <nav class="topbar">
      <div class="topbar-inner">
        <button class="hamb" type="button" @click="toggleMenu" aria-label="Abrir menu"><span></span><span></span><span></span></button>
        <router-link to="/dashboard" class="top-brand">
          <img src="/assets/afrogato/logo-afrogato.png" alt="Afrogato" />
          <span>Afrogato</span>
        </router-link>
        <div v-if="showPoints" class="points-chip">{{ formattedPoints }} pts</div>
        <router-link v-else class="preview-link" to="/wallet">Mi wallet</router-link>
      </div>
    </nav>
  </div>
</template>

<script>
import { mapActions } from 'vuex'
import axios from 'axios'

export default {
  name: 'NavBar',
  data() { return { menuOpen: false, walletPoints: null } },
  computed: {
    isAdmin() {
      return ['administrador', 'superadministrador'].includes(this.$store.state.role)
    },
    showPoints() {
      return this.$route.path === '/wallet' && this.walletPoints !== null
    },
    formattedPoints() {
      const n = Number(this.walletPoints || 0)
      return Number.isInteger(n) ? String(n) : n.toFixed(2).replace(/0+$/, '').replace(/\.$/, '')
    }
  },
  watch: {
    '$route.path': { immediate: true, handler(path) { if (path === '/wallet') this.loadPoints() } },
    '$store.state.user.token'() { if (this.$route.path === '/wallet') this.loadPoints() }
  },
  mounted() { window.addEventListener('wallet-balance-updated', this.walletBalanceChanged) },
  beforeUnmount() { this._pointsRequest = (this._pointsRequest || 0) + 1; window.removeEventListener('wallet-balance-updated', this.walletBalanceChanged) },
  methods: {
    ...mapActions(['logout']),
    toggleMenu() { this.menuOpen = !this.menuOpen },
    closeMenu() { this.menuOpen = false },
    async loadPoints() {
      const request = this._pointsRequest = (this._pointsRequest || 0) + 1
      const token = this.$store.state.user && this.$store.state.user.token
      if (!token) return
      try {
        const { data } = await axios.get('/api/loyalty/wallet', { params: { include_history: 0 }, headers: { Authorization: `Bearer ${token}` } })
        if (request === this._pointsRequest) this.walletPoints = data?.account?.points_balance ?? 0
      } catch (_error) {
        if (request === this._pointsRequest) this.walletPoints = null
      }
    },
    walletBalanceChanged(event) { if (this.$route.path !== '/wallet' || !Number.isFinite(event.detail) || event.detail < 0) return; this._pointsRequest = (this._pointsRequest || 0) + 1; this.walletPoints = event.detail },
    logoutAndClose() {
      this.logout()
      this.closeMenu()
      this.$router.push('/login')
    }
  }
}
</script>

<style scoped>
.overlay { position: fixed; inset: 0; background: rgba(0,0,0,.48); backdrop-filter: blur(6px); z-index: 40; }
.topbar { position: fixed; top: 0; left: 0; right: 0; height: 64px; z-index: 30; background: rgba(18, 23, 14, .88); border-bottom: 1px solid rgba(221,169,78,.25); backdrop-filter: blur(14px); }
.topbar-inner { height: 64px; max-width: 1360px; margin: 0 auto; display: grid; grid-template-columns: 54px 1fr 120px; align-items: center; gap: 10px; padding: 0 16px; }
.hamb { width: 44px; height: 44px; border-radius: 50%; border: 1px solid rgba(244,223,185,.35); background: rgba(255,255,255,.06); color: #f4dfb9; cursor: pointer; display: grid; place-items: center; gap: 0; padding: 10px; }
.hamb span { display: block; width: 18px; height: 2px; border-radius: 99px; background: #f4dfb9; }
.top-brand { justify-self: center; display: flex; align-items: center; gap: 10px; color: #f4dfb9; text-decoration: none; font-family: Georgia, 'Times New Roman', serif; font-weight: 900; letter-spacing: .06em; }
.top-brand img { width: 70px; height: 48px; object-fit: contain; object-position: center; filter: drop-shadow(0 4px 6px rgba(0,0,0,.22)); }
.preview-link { justify-self: end; color: #d6a34b; text-decoration: none; font-weight: 900; text-transform: uppercase; letter-spacing: .08em; font-size: 12px; }
.points-chip { justify-self: end; border: 1px solid rgba(214,163,75,.5); background: rgba(214,163,75,.14); color: #f4dfb9; border-radius: 999px; padding: 8px 12px; font-weight: 1000; font-size: 13px; white-space: nowrap; }
.sidebar { position: fixed; top: 0; bottom: 0; left: 0; width: min(340px, 92vw); background: linear-gradient(180deg, #f3dfbd, #e6c894); z-index: 50; transform: translateX(-105%); transition: transform .22s ease; box-shadow: 24px 0 60px rgba(0,0,0,.32); padding: 18px; overflow-y: auto; }
.sidebar.is-open { transform: translateX(0); }
.side-head { display: flex; align-items: center; justify-content: space-between; border-bottom: 1px dashed rgba(38,51,31,.5); padding-bottom: 14px; margin-bottom: 18px; }
.side-head img { width: 150px; }
.icon-btn { border: 1px solid rgba(38,51,31,.35); background: rgba(255,255,255,.34); color: #26331f; width: 36px; height: 36px; border-radius: 50%; cursor: pointer; font-weight: 900; }
.menu-links { display: grid; gap: 10px; }
.nav-link { border: 1px solid rgba(38,51,31,.18); background: rgba(255,248,230,.56); color: #17120d; border-radius: 16px; padding: 14px; text-decoration: none; font-weight: 900; text-align: left; cursor: pointer; }
.nav-link.router-link-active, .nav-link:hover { background: #26331f; color: #f4dfb9; }
.nav-link.danger { color: #6b2f21; width: 100%; }
@media (max-width: 620px) { .preview-link { display: none; } .top-brand span { display: none; } .topbar-inner { grid-template-columns: 54px 1fr 100px; } }
</style>
